import type { ProviderConfig } from "../schema/provider.js";
import { DEFAULT_CONSOLE_PROVIDER } from "../schema/provider-core.js";

/** Ensures at least the console provider when the list is empty */
export function resolveProviderConfigs(
  providers: ProviderConfig[] | undefined,
): ProviderConfig[] {
  if (!providers || providers.length === 0) {
    return [DEFAULT_CONSOLE_PROVIDER];
  }
  return providers;
}
